/* eslint-disable @typescript-eslint/no-explicit-any */
import ChatCheckbox from 'core/chatbot/components/atoms/ChatCheckbox';
import Icon from 'core/modules/atoms/Icon';
import SelectCustomizableBase from 'core/modules/atoms/SelectCustomizable';
import React from 'react';
import './_multi-select-with-checkbox.scss';

const SelectCustomizable = SelectCustomizableBase as any;

type OptionType = {
  value: string;
  label: string;
};

type MultiSelectWithCheckboxProps = {
  options: OptionType[];
  value: OptionType[];
  onChange: (selected: OptionType[] | null) => void;
  placeholder?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  maxVisibleValues?: number;
  name?: string;
  label?: string | null;
  required?: boolean;
};

// Custom MultiValue to limit visible badges and show "+N" overflow
const LimitedMultiValue = (props: any) => {
  const { index, getValue, selectProps, data, removeProps } = props;
  const maxVisible = selectProps.maxVisibleValues ?? 1;
  const allValues = getValue();

  if (index < maxVisible) {
    return (
      <div className="multi-select-checkbox__badge">
        <span className="multi-select-checkbox__badge-text">{data.label}</span>
        <button
          type="button"
          className="multi-select-checkbox__badge-remove"
          onClick={(e) => {
            e.stopPropagation();
            removeProps.onClick(e);
          }}
          aria-label={`Remove ${data.label}`}
        >
          ×
        </button>
      </div>
    );
  }

  if (index === maxVisible) {
    const overflowCount = allValues.length - maxVisible;
    return (
      <div className="multi-select-checkbox__badge multi-select-checkbox__badge--count">
        <span className="multi-select-checkbox__badge-text">+{overflowCount}</span>
      </div>
    );
  }

  return null;
};

// Custom Option using existing ChatCheckbox component
const CheckboxOption = (props: any) => {
  const { isSelected, label, innerRef, innerProps } = props;

  return (
    <div ref={innerRef} {...innerProps} className={`multi-select-checkbox__option ${isSelected ? 'multi-select-checkbox__option--selected' : ''}`}>
      <ChatCheckbox checked={isSelected} label={label} onChange={() => {}} />
    </div>
  );
};

// Custom DropdownIndicator to use Icon component instead of CSS background SVG
const CustomDropdownIndicator = (props: any) => {
  const { innerProps } = props;
  return (
    <div className="select-customizable__indicator" {...innerProps}>
      <Icon type="chevron-down" size="s" color="grey-01" />
    </div>
  );
};

function MultiSelectWithCheckbox({
  options,
  value,
  onChange,
  placeholder,
  isDisabled = false,
  isLoading = false,
  maxVisibleValues = 1,
  name,
  label,
  required = false,
}: MultiSelectWithCheckboxProps): JSX.Element {
  return (
    <div className="multi-select-checkbox">
      <SelectCustomizable
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isMulti={true}
        isSearchable={false}
        isDisabled={isDisabled}
        isLoading={isLoading}
        closeMenuOnSelect={false}
        menuPosition="absolute"
        name={name}
        label={label}
        required={required}
        components={{
          DropdownIndicator: CustomDropdownIndicator,
          MultiValue: LimitedMultiValue,
          Option: CheckboxOption,
        }}
        maxVisibleValues={maxVisibleValues}
      />
    </div>
  );
}

export default MultiSelectWithCheckbox;
